/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_bmi_hub_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What is BMI?`)
};

const es_bmi_hub_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Qué es el IMC?`)
};

const de_bmi_hub_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Was ist BMI?`)
};

const nl_bmi_hub_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wat is BMI?`)
};

const fr_bmi_hub_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Qu'est-ce que l'IMC ?`)
};

const it_bmi_hub_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Che cos'è il BMI?`)
};

const pt_br2_bmi_hub_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O que é BMI?`)
};

const pt_bmi_hub_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O que é IMC?`)
};

const ja_bmi_hub_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`BMIとは何ですか？`)
};

const zh_bmi_hub_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`什么是 BMI？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const bmi_hub_faq1_q = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.bmi_hub_faq1_q(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("bmi_hub_faq1_q", locale)
	if (locale === "en") return en_bmi_hub_faq1_q(inputs)
	if (locale === "es") return es_bmi_hub_faq1_q(inputs)
	if (locale === "de") return de_bmi_hub_faq1_q(inputs)
	if (locale === "nl") return nl_bmi_hub_faq1_q(inputs)
	if (locale === "fr") return fr_bmi_hub_faq1_q(inputs)
	if (locale === "it") return it_bmi_hub_faq1_q(inputs)
	if (locale === "pt-BR") return pt_br2_bmi_hub_faq1_q(inputs)
	if (locale === "pt") return pt_bmi_hub_faq1_q(inputs)
	if (locale === "ja") return ja_bmi_hub_faq1_q(inputs)
	return zh_bmi_hub_faq1_q(inputs)
};